import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { FunctionColor, Tag, TitlePreset } from '@lux/title';
import { Translate, TranslateScope } from '@pegasus/translation';
import { Campaign } from '@shared/types/mylounge';
import { trackViewContent } from '@browsing/tracking';
import CampaignVolumeCarousel from './campaign-volume-carousel';

import * as S from '../mylounge-wrapper.styles';

interface MoreCampaignsSectionProps {
    campaigns: Campaign[];
    moreCampaignsCount: number;
    onExpandClick: () => void;
}

const ShowMoreCampaignsSection: React.FC<MoreCampaignsSectionProps> = ({
    campaigns,
    moreCampaignsCount,
    onExpandClick,
}) => {
    const { ref: expandInViewRef, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            trackViewContent('see_all_button', {});
        }
    }, [inView]);

    return (
        <TranslateScope>
            <S.MoreCampaignsWrapper ref={expandInViewRef}>
                <S.MoreCampaignTitle
                    id="campaign-volumes-title"
                    data-testid="campaign-volumes-title"
                    tag={Tag.H2}
                    preset={TitlePreset.XS}
                    color={FunctionColor.function100}
                >
                    <Translate message="campaignVolumes.sectionTitle" />
                </S.MoreCampaignTitle>
                <TranslateScope path="myLounge">
                    <CampaignVolumeCarousel campaigns={campaigns} />
                </TranslateScope>
                <Button
                    buttonType={ButtonType.primary}
                    color={ButtonColor.dark}
                    onClick={onExpandClick}
                    data-testid="expand-button"
                >
                    <Translate
                        message="campaignVolumes.buttonTitle"
                        params={{ count: moreCampaignsCount }}
                        raw
                    />
                </Button>
            </S.MoreCampaignsWrapper>
        </TranslateScope>
    );
};

export default ShowMoreCampaignsSection;
